import React, { Component } from "react";
import PropTypes from "prop-types";
import ComponentScroll from "./ComponentScroll";
import Correction from "./Correction";
import { Card } from "material-ui";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({});

class CorrectionScroll extends Component {
    static propTypes = {
        hasMore: PropTypes.bool.isRequired,
        edges: PropTypes.object.isRequired,
        loadMore: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        emptyStateMessage: PropTypes.string,
        onGotoPost: PropTypes.func,
        currentUserId: PropTypes.string,
        onReactionButtonClick: PropTypes.func,
        onCorrectionMenuItemClick: PropTypes.func,
        t: PropTypes.func.isRequired
    };

    static defaultProps = {
        emptyStateMessage: "",
        onGotoPost: () => {}
    };

    renderer = node => {
        const {
            currentUserId,
            onReactionButtonClick,
            onCorrectionMenuItemClick
        } = this.props;
        return (
            <Card>
                <Correction
                    onMenuItemClick={onCorrectionMenuItemClick}
                    currentUserId={currentUserId}
                    onReactionButtonClick={onReactionButtonClick}
                    correction={node}
                    showGoToPost={true}
                    onGotoPost={this.props.onGotoPost}
                    edit={false}
                />
            </Card>
        );
    };

    render() {
        let { t, edges, loadMore, hasMore, emptyStateMessage } = this.props;

        if (!emptyStateMessage) {
            emptyStateMessage = t(
                "correctionScroll.There are no corrections to display"
            );
        }
        return (
            <ComponentScroll
                emptyStateMessage={emptyStateMessage}
                edges={edges}
                renderComponent={this.renderer}
                loadMore={loadMore}
                hasMore={hasMore}
            />
        );
    }
}
export default withStylesAndTranslation(CorrectionScroll, styleSheet);



// WEBPACK FOOTER //
// ./src/components/CorrectionScroll.jsx